import { ReactNode, RefObject, useRef } from 'react';

interface WithCopyableProps {
  children: (ref: RefObject<HTMLDivElement>) => ReactNode;
}

export const WithCopyable = ({ children }: WithCopyableProps) => {
  const ref = useRef(null);
  return <>{children(ref)}</>;
};
